import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Popconfirm,
  Select,
  Spin,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getParamValue, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import MethodDetails from "./Details";
import { responseNotification } from "../../utils/notify";
import AddMethod from "./AddMethod";

const { Option } = Select;

const PaymentMethodList = () => {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [searchKey, setSearchKey] = useState("");
  const [visible, setVisible] = useState(undefined);
  const [methodData, setMethodData] = useState({
    loading: false,
    data: null,
  });
  const [selectedMethodForEdit, setSelectedMethodForEdit] = useState(undefined);

  const [methodOptions, setMethodOptions] = useState({
    loading: false,
    list: null,
  });
  const [selectedMethod, setSelectedMethod] = useState(undefined);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setSearchKey("");
    setType("JC_MART");
    form.resetFields();
  };

  // const handleChangeStatus = (value: string) => {
  //   setStatus(value);
  // };

  const getMethod = useCallback(async () => {
    setMethodData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_PAY_API}`;
    axios
      .get(
        `${encodedUri}/payment-method?page=${page || 0}&limit=${limit || 16}` +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``) +
          (searchKey ? `&key=${searchKey}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setMethodData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setMethodData({ loading: false, data: [] });
        console.error("Method: Error", err);
      });
  }, [limit, status, page, type, searchKey]);

  const showPopconfirm = (id) => {
    setVisible(id);
  };

  const handleCancel = () => {
    setVisible(undefined);
  };

  //
  const onDelete = async (id) => {
    if (id) {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/payment-method/deleted`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            paymentMethodId: id,
            deleted: true,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Method Deleted Successfully", "success");
            getMethod();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //
  useEffect(() => {
    getMethod();
  }, [getMethod]);

  useEffect(() => {
    if (visible) {
      setSelectedMethod(undefined);
      setSelectedMethodForEdit(undefined);
    }
  }, [selectedMethod, selectedMethodForEdit, visible]);

  useEffect(() => {
    setSelectedMethod(undefined);
    setSelectedMethodForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedMethod(null);
    setSelectedMethodForEdit(null);
    getMethod();
    setVisible(undefined);
  };

  return (
    <React.Fragment>
      <TopHeading total={methodData?.data?.totalElements} refetch={getMethod} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              value={type}
              style={{ minWidth: 300 }}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Payment Method</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Title</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Description</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {methodData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {methodData?.data?.methods?.length ? (
                    methodData?.data?.methods?.map((method, index) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedMethod(method)}
                        >
                          <div className="single-product">
                            <Avatar
                              shape="square"
                              size={45}
                              src={method?.logo}
                              className="mr-3"
                            />
                            <span className="name">{method?.name}</span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {method?.title || "..."}
                            </span>
                          </div>

                          <div className="single-product">
                            <span className="name">
                              {method?.type?.replace("_", " ")}
                            </span>
                          </div>

                          <div className="single-product">
                            <span className="name">{method?.description}</span>
                          </div>

                          <div className="single-product">
                            <button
                              className="btn btn-sm btn-warning mx-1"
                              onClick={() => setSelectedMethodForEdit(method)}
                            >
                              <EditOutlined />
                            </button>

                            <Popconfirm
                              placement="left"
                              title="Are you sure to delete?"
                              visible={method?.id === visible}
                              onConfirm={() => onDelete(method?.id)}
                              okButtonProps={{ loading: confirmLoading }}
                              onCancel={handleCancel}
                            >
                              <button
                                className="btn btn-sm btn-danger mx-1"
                                onClick={() => showPopconfirm(method?.id)}
                              >
                                <DeleteOutlined />
                              </button>
                            </Popconfirm>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Methods" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedMethodForEdit ? "Edit Method" : "Method Details"}
            width={500}
            onClose={onClose}
            visible={selectedMethod || selectedMethodForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={false}
          >
            {selectedMethodForEdit ? (
              <AddMethod
                visibleData={selectedMethodForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <MethodDetails MethodDetails={selectedMethod} />
            )}
          </Drawer>

          <PaginationTwo
            {...methodData.data}
            limit={limit}
            page={methodData?.data?.currentPageNumber || 0}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default PaymentMethodList;
